/** Hilfen für Objekte: Beträge in Cent, Anzeige in Euro. */
export const cents = (euro: number): number => Math.round((Number.isFinite(euro) ? euro : 0) * 100);
export const euroWert = (c: number): number => c / 100;
